import type { ComicCategory } from './types';

export const categories: ComicCategory[] = [
  {
    id: 'cat-1',
    slug: 'romance',
    name: '恋爱甜宠',
    description: '甜蜜浪漫的爱情故事，让你心跳加速的心动瞬间',
    count: 1856,
    imageSeq: 'cat-romance-01',
    imageQuery: 'Korean%20romance%20webtoon%20illustration%20couple%20holding%20hands%20under%20cherry%20blossom%20tree%20soft%20pink%20warm%20lighting%20dreamy%20atmosphere%20pastel%20color%20palette%20gentle%20emotional%20scene%20elegant%20manhwa%20art%20style%20clean%20background',
  },
  {
    id: 'cat-2',
    slug: 'action',
    name: '热血动作',
    description: '激燃打斗场面，感受肾上腺素飙升的畅快体验',
    count: 1243,
    imageSeq: 'cat-action-01',
    imageQuery: 'Korean%20action%20webtoon%20dynamic%20fight%20scene%20martial%20arts%20intense%20battle%20pose%20dramatic%20lighting%20fiery%20orange%20red%20background%20powerful%20energy%20explosion%20effects%20manhwa%20art%20style%20epic%20composition',
  },
  {
    id: 'cat-3',
    slug: 'thriller',
    name: '惊悚悬疑',
    description: '扣人心弦的悬疑推理，层层反转让你欲罢不能',
    count: 867,
    imageSeq: 'cat-thriller-01',
    imageQuery: 'Korean%20thriller%20webtoon%20dark%20alleyway%20mysterious%20shadow%20figure%20dim%20streetlight%20foggy%20atmosphere%20cold%20blue%20gray%20tones%20suspenseful%20noir%20style%20manhwa%20art%20tense%20mood%20clean%20composition',
  },
  {
    id: 'cat-4',
    slug: 'fantasy',
    name: '奇幻冒险',
    description: '穿越异世界，魔法与剑的史诗冒险等你探索',
    count: 1542,
    imageSeq: 'cat-fantasy-01',
    imageQuery: 'Korean%20fantasy%20webtoon%20magical%20kingdom%20castle%20floating%20islands%20glowing%20crystals%20mystical%20forest%20warm%20golden%20emerald%20light%20enchanting%20atmosphere%20manhwa%20art%20style%20lush%20detailed%20environment',
  },
  {
    id: 'cat-5',
    slug: 'comedy',
    name: '搞笑日常',
    description: '轻松幽默的日常生活，笑到停不下来的欢乐时光',
    count: 956,
    imageSeq: 'cat-comedy-01',
    imageQuery: 'Korean%20comedy%20webtoon%20funny%20school%20life%20chibi%20characters%20laughing%20together%20bright%20sunny%20classroom%20yellow%20cheerful%20color%20palette%20playful%20vibrant%20manhwa%20art%20style%20happy%20warm%20atmosphere',
  },
  {
    id: 'cat-6',
    slug: 'drama',
    name: '都市情感',
    description: '现实都市中的情感纠葛，引发共鸣的人生百态',
    count: 1089,
    imageSeq: 'cat-drama-01',
    imageQuery: 'Korean%20drama%20webtoon%20cityscape%20night%20view%20lonely%20office%20worker%20by%20window%20rainy%20mood%20warm%20apartment%20lights%20reflective%20atmosphere%20muted%20teal%20gray%20tones%20manhwa%20art%20style%20emotional%20realistic',
  },
  {
    id: 'cat-7',
    slug: 'horror',
    name: '恐怖灵异',
    description: '毛骨悚然的灵异故事，挑战你的胆量极限',
    count: 534,
    imageSeq: 'cat-horror-01',
    imageQuery: 'Korean%20horror%20webtoon%20haunted%20mansion%20dark%20corridor%20flickering%20candle%20light%20eerie%20shadow%20crimson%20accents%20gothic%20atmosphere%20manhwa%20art%20style%20chilling%20mood%20deep%20shadows%20clean%20composition',
  },
  {
    id: 'cat-8',
    slug: 'historical',
    name: '古风历史',
    description: '穿越古今的传奇故事，感受历史与文化的魅力',
    count: 723,
    imageSeq: 'cat-historical-01',
    imageQuery: 'Korean%20historical%20webtoon%20ancient%20palace%20courtyard%20traditional%20hanbok%20clothing%20elegant%20noble%20figure%20soft%20golden%20sunset%20light%20cherry%20blossom%20petals%20classic%20manhwa%20art%20style%20serene%20atmosphere',
  },
  {
    id: 'cat-9',
    slug: 'slice-of-life',
    name: '治愈日常',
    description: '温暖治愈的日常故事，在平凡中发现美好与感动',
    count: 645,
    imageSeq: 'cat-healing-01',
    imageQuery: 'Korean%20healing%20webtoon%20cozy%20cafe%20interior%20cat%20sleeping%20on%20windowsill%20warm%20sunlight%20steaming%20coffee%20cup%20gentle%20cream%20beige%20tones%20peaceful%20slice%20of%20life%20manhwa%20art%20style%20soft%20atmosphere',
  },
];

export const featuredCategories = categories.slice(0, 6);